import BaseServicesAxios from '../../infrastructure/services';
import { IContratacaoV2Get, IContratacaoV2Post } from './ContratacaoV2Type';

const authHeader = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  },
});

export const getAllV2 = async (pageNumber = 1, pageSize = 1000): Promise<IContratacaoV2Get[]> => {
  const response = await BaseServicesAxios.get(
    `/ContratacaoV2/ObterTodos?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    authHeader()
  );
  return response.data;
};

export const getByIdV2 = async (id: string): Promise<IContratacaoV2Get> => {
  const response = await BaseServicesAxios.get(
    `/ContratacaoV2/ObterPorId?id=${id}`,
    authHeader()
  );
  return response.data;
};

export const cadastrarV2 = async (obj: IContratacaoV2Post): Promise<IContratacaoV2Get> => {
  const response = await BaseServicesAxios.post(
    `/ContratacaoV2/Cadastrar`,
    obj,
    authHeader()
  );
  return response.data;
};

export const obterContratoPdf = async (id: string): Promise<Blob> => {
  const response = await BaseServicesAxios.get(
    `/ContratacaoV2/ObterContrato?id=${id}`,
    { ...authHeader(), responseType: 'blob' }
  );
  return response.data;
};
